import { gql } from "./client";

export const PageFragment = `
  fragment PageFragment on Page {
    name
    layout
    backgroundColor
    pageLinks {
      name
      url
      thumbnail(w: 800)
      textColor
      backgroundColor
      showLabel
    }
  }
`;

export const MapFragment = `
  fragment MapFragment on Map {
    id
    title
    backgroundColor
    connectionColor
    pinColor
    waypointColor
    textColor
    textStrokeColor

    fonts {
      id
      fontName
      resourceUrl
      preconnectUrl
    }

    template {
      id
      name
      rotation(offset: -90)
      width
      height
      layerImages
      geopoints {
        id
        geopoint
        position
      }
    }

    icons {
      id
      color
      x
      y
      rotation
      size
      src
    }

    textboxes {
      id
      color
      x
      y
      fontFamily
      fontSize
      fontWeight
      rotation
      text
      textAlign
      width
      placeId
      iconColor
      iconSize
      iconOffset
      iconSrc
      zoomMin
      zoomMax
    }

    waypoints {
      id
      x
      y
      gravity
      shape
      rotation
      placeId
      hazard
    }
  }
`;

export const EventHoursFragment = `
  fragment EventHoursFragment on EventHours {
    id
    startDate
    endDate
    startTime
    endTime
    weekdays
    eventId
    placeId

    overrides {
      startTime
      endTime
      date
      cancelled
    }
  }
`;

export const GetMap = gql(`
  ${MapFragment}

  query GetMap($id: ID!) {
    map(id: $id) {
      ...MapFragment

      places {
        id
        mapId
        canonicalStatus
        canonicalStatusNote
        overrideStatus
        overrideStatusNote
        overrideStatusExpiration
      }
    }
  }
`);

export const GetSchedule = gql(`
  ${EventHoursFragment}

  query GetSchedule($id: ID!) {
    schedule(id: $id) {
      title
      eventHours {
        ...EventHoursFragment
      }
    }
  }
`);
